import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {MatDialog} from '@angular/material/dialog';
import {take, takeUntil} from 'rxjs/operators';
import {DialogService} from '@shared/services/dialog-service';
import {DialogModel} from '@shared/models/dialog.model';
import { SpreadsheetState } from '../store/spreadsheet.reducer';
import { select, Store } from '@ngrx/store';
import { getCurrentProject, ProjectState } from '@features/projects/store/reducers/projects.reducer';
import { ProjectModel } from '@features/projects/models/projects.models';
import { CommandService } from '@core/services/command.service';
import { Router } from '@angular/router';
import { FlexSheetService } from './flex-sheet.service';

@Injectable({
  providedIn: 'root',
})

export class CreateQuestionnaireFromExcelCommandHandler implements IPlatformCommandHandler {
  constructor(
    protected dialogService: DialogService,
    private flexSheetService: FlexSheetService) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const currentWorksheet = this.flexSheetService.getCurrentWorkSheet();
    const currentWorkbook = this.flexSheetService.getCurrentWorkBook();
    const workbookId = currentWorkbook.id;
    const worksheetId = currentWorksheet.id;
    const workbookName = currentWorkbook.name;
    const worksheetName = currentWorksheet.name;
    const workbookSetId = command.fieldValues['ItemId'];

    command.fieldValues['WorkbookName'] = workbookName;
    command.fieldValues['WorkbookFilename'] = currentWorkbook.fileName;
    command.fieldValues['WorksheetName'] = worksheetName;
    command.fieldValues['WorksheetId'] = worksheetId;
    command.fieldValues['WorkbookId'] = workbookId;
    command.fieldValues['WorkbookSetId'] = workbookSetId;
    handler.executeCommand(command);
     return true;
    }
}
